import { useState, useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import { ProductsPage } from './ProductsPage';
import { ProductForm } from '../components/ProductForm';
import { MasterDataPage } from './MasterDataPage';

type View = 'products' | 'create' | 'edit' | 'master';

export function CatalogPage() {
  const [searchParams] = useSearchParams();
  const [view, setView] = useState<View>(searchParams.get('create') === 'true' ? 'create' : 'products');
  const [editId, setEditId] = useState('');
  const [tab, setTab] = useState<'products' | 'master'>('products');
  const [initialStatusFilter, setInitialStatusFilter] = useState<'all' | 'active' | 'inactive' | 'pending_approval'>('active');

  useEffect(() => {
    if (searchParams.get('create') === 'true') {
      setView('create');
    }
  }, [searchParams]);

  const handleBack = (submittedPending?: boolean) => {
    if (submittedPending) {
      setInitialStatusFilter('pending_approval');
    }
    setView('products');
  };

  if (view === 'create') return <div className="p-6"><ProductForm onBack={handleBack} /></div>;
  if (view === 'edit') return <div className="p-6"><ProductForm productId={editId} onBack={() => setView('products')} /></div>;

  return (
    <div className="h-full flex flex-col">
      {/* Tab toggle */}
      <div className="px-6 pt-6 pb-0 flex gap-4 border-b">
        <button onClick={() => { setTab('products'); setView('products'); }} className={`pb-3 text-sm font-medium border-b-2 transition ${tab === 'products' ? 'border-primary text-primary' : 'border-transparent text-muted-foreground hover:text-foreground'}`}>Products & Services</button>
        <button onClick={() => setTab('master')} className={`pb-3 text-sm font-medium border-b-2 transition ${tab === 'master' ? 'border-primary text-primary' : 'border-transparent text-muted-foreground hover:text-foreground'}`}>Master Data</button>
      </div>
      <div className="flex-1 overflow-auto">
        {tab === 'products' && (
          <div className="p-6">
            <ProductsPage
              onCreateNew={() => setView('create')}
              onEdit={(id) => { setEditId(id); setView('edit'); }}
              initialStatusFilter={initialStatusFilter}
            />
          </div>
        )}
        {tab === 'master' && <MasterDataPage />}
      </div>
    </div>
  );
}
